import { registerPlugin } from '@capacitor/core';
import { useAppStore } from '@/store/appStore';

export interface NativeLoginResult {
    success: boolean;
    dismissed?: boolean;
}

export interface NativeLoginOptions {
    /**
     * The device's current anonymous (guest) account. The sheet passes it to
     * `/api/auth/firebase` so the backend upgrades that row instead of creating
     * a second user. Defaults to the signed-in user when that user is a guest —
     * both apps now create guests from the web layer (Auth.tsx), so the id the
     * native onboarding used to store in UserDefaults is no longer there.
     */
    anonymousUserId?: number;
}

interface NativeLoginPluginInterface {
    showLogin(options?: NativeLoginOptions): Promise<NativeLoginResult>;
}

const Plugin = registerPlugin<NativeLoginPluginInterface>('NativeLoginPlugin');

export const NativeLoginPlugin: NativeLoginPluginInterface = {
    showLogin(options) {
        const user = useAppStore.getState().user;
        const anonymousUserId = options?.anonymousUserId ?? (user?.is_anonymous ? user.id : undefined);
        return Plugin.showLogin(anonymousUserId ? { ...options, anonymousUserId } : options);
    },
};
